module.exports = __webpack_public_path__ + "img/gh.77872d15.svg";